import { render } from "./SearchMatrimonyListingResults.vue?vue&type=template&id=56294ce0&scoped=true"
import script from "./SearchMatrimonyListingResults.vue?vue&type=script&lang=js"
export * from "./SearchMatrimonyListingResults.vue?vue&type=script&lang=js"

import "./SearchMatrimonyListingResults.vue?vue&type=style&index=0&id=56294ce0&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56294ce0"]])

export default __exports__